/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notification': {
    width: 15,
    height: 24,
    viewBox: '0 0 15 24',
    data: '<g transform="translate(0 .62)" _fill="none" fill-rule="evenodd"><path pid="0" d="M11.585 9.41a.342.342 0 0 0-.31-.197H7.226l3.996-6.31a.341.341 0 0 0-.289-.524H5.467a.342.342 0 0 0-.306.19L.036 12.818a.341.341 0 0 0 .306.494h3.513L.027 22.405a.342.342 0 0 0 .576.353L11.537 9.775a.342.342 0 0 0 .048-.365z" _fill="#A7B3BB" fill-rule="nonzero"/><circle pid="1" _stroke="#234357" stroke-width="1.36" _fill="#4FCA00" cx="11.617" cy="3.25" r="2.57"/></g>'
  }
})
